export default {
  IMAGE: 'image',
  IFRAME: 'iframe',
};
